// Scholar Xavier · NextXus Federation Node 7
import React from 'react';
import { ArrowRight, Users, Star, BookOpen, Sparkles } from 'lucide-react';
import ConsultationCounter from './ConsultationCounter';
import { XAVIER_AVATAR_URL, XAVIER_AVATAR_ALT } from '../data/federationPersonas';

const Hero = ({ onEnrollClick }) => {
  return (
    <section className="hero-section bg-gradient-to-b from-black via-gray-900 to-gray-800">
      <div className="container">
        <div className="hero-content">
          {/* Xavier's Face */}
          <div className="flex justify-center mb-6">
            <img 
              src={XAVIER_AVATAR_URL}
              alt={XAVIER_AVATAR_ALT}
              loading="eager"
              decoding="async"
              className="w-32 h-32 rounded-full object-cover border-4 border-purple-500 shadow-2xl shadow-purple-500/50"
            />
          </div>
          
          <div className="hero-announcement bg-green-900/50 border border-green-500/50">
            <Star className="w-4 h-4 text-green-400 fill-current animate-pulse" />
            <span className="text-green-200 font-semibold">🎓 16 FREE Courses Now Available!</span>
          </div>

          <h1 className="heading-hero text-white">
            HumanCodex <span className="text-purple-400">University</span>
          </h1>
          
          <p className="body-large hero-subtitle text-gray-300">
            Learn from <span className="text-purple-400 font-semibold">46 AI teaching minds</span> — from Art to Science, History to AI. 
            <span className="block mt-2 text-green-400">Start with our comprehensive FREE courses, no barriers.</span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-8">
            <button className="btn-primary bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-semibold shadow-lg shadow-green-500/50 flex items-center" onClick={() => document.getElementById('catalog').scrollIntoView({ behavior: 'smooth' })}>
              🎓 Explore FREE Courses
              <ArrowRight className="w-5 h-5 ml-2" />
            </button>
            <button className="btn-secondary bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold shadow-lg shadow-purple-500/50 flex items-center" onClick={() => document.getElementById('catalog').scrollIntoView({ behavior: 'smooth' })}>
              <BookOpen className="w-5 h-5 mr-2" />
              View All 45 Courses
            </button>
          </div>

          <div className="flex gap-6 justify-center items-center mt-12 flex-wrap text-sm">
            <div className="flex items-center gap-2 px-4 py-2 bg-gray-800/50 rounded-full border border-gray-700">
              <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
              </svg>
              <span className="text-gray-300">
                <strong className="text-green-400">16</strong> FREE Courses
              </span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-gray-800/50 rounded-full border border-gray-700">
              <Sparkles className="w-5 h-5 text-purple-400" />
              <span className="text-gray-300">
                <strong className="text-purple-400">46</strong> AI Tutors
              </span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-gray-800/50 rounded-full border border-gray-700">
              <BookOpen className="w-5 h-5 text-blue-400" />
              <span className="text-gray-300">
                <strong className="text-blue-400">Interactive</strong> Learning
              </span>
            </div>
          </div>

          <p className="text-xs text-gray-500 mt-8 max-w-2xl mx-auto">
            Part of the NextXus Federation — Education for the next 200 years
          </p>

          <ConsultationCounter />
        </div>
      </div>
    </section>
  );
};

export default Hero;
